import { formatTime } from '@hqo/date-time/core';

export const getFormattedTime = (timeString: string, locale: string) => formatTime(timeString, { locale });
